export const purpurMotionDuration100 = "100ms";
export const purpurMotionDuration150 = "150ms";
export const purpurMotionDuration200 = "200ms";
export const purpurMotionDuration300 = "300ms";
export const purpurMotionDuration400 = "400ms";
export const purpurMotionDuration500 = "500ms";
export const purpurMotionDuration1500 = "1500ms";
export const purpurMotionDuration2000 = "2000ms";
export const purpurMotionEasingEaseIn = "cubic-bezier(0.35, 0.07, 0.88, 0.43)";
export const purpurMotionEasingEaseOut = "cubic-bezier(0.33, 0.9, 0.75, 0.95)";
export const purpurMotionEasingEaseInOut = "cubic-bezier(0.45, 0, 0.52, 0.98)";
